export default "__VITE_ASSET__BKiQ49aQ__"